import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import TextField from "@material-ui/core/TextField";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import CancelIcon from "@material-ui/icons/Cancel";
import React, {useEffect, useRef, useState} from "react";
import {useStyles} from "./constants";
import {simulate_evaluate} from "./functions";
import {
    Checkbox, DialogActions,
    FormControlLabel,
    FormGroup,
    FormLabel, InputAdornment
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";

export default function Filters(props) {


    const classes = useStyles();
    const inputName = useRef(null);
    const inputFormula = useRef(null)
    const inputime = useRef(null)
    const [errorVars, setErrorVars] = useState(false)
    const [open, setOpen] = React.useState(false);
    const [open2, setOpen2] = React.useState(false);
    const [forbidfamilies, setFamilies] = React.useState(null)
    const [filters, setFilters] = useState(null)


    useEffect(() => {
        setFilters(props.filters)
        setFamilies(props.filters.forbidfamilies)
    }, [props.filters])

    if (filters == null || forbidfamilies == null)
        return null
    // console.log(filters)
    // --------------------------------------------------------------------------------------------------

    function changeTimeLimit(e) {
        e.preventDefault();
        props.setFilters({...filters, timeLimit: e.target.elements[0].value})
    }

    let time = <List style={{margin: '0 20px'}}>
        <form onSubmit={e => changeTimeLimit(e)} className={classes.root} noValidate>
            <TextField ref={inputime} onChange={e => setFilters({...filters, timeLimit: e.target.value})}
                       margin={"dense"} id="standard-basic" variant={'outlined'}
                       label="Time Limit" value={filters.timeLimit} fullWidth/>
        </form>
        <br/>
    </List>

    // --------------------------------------------------------------------------------------------------
    function changeName(e) {
        e.preventDefault();
        props.setFilters({...props.filters, name: e.target.value})
    }

    function resetName(e) {
        e.preventDefault();
        props.setFilters({...props.filters, name: ""})
    }

    const handleCloseName = (e) => {
        if (e._reactName === "onKeyDown" && e.keyCode !== 27)
            return;
        setOpen2(false);
    }

    function handleOpenName(e) {
        e.preventDefault()
        setOpen2(true)
    }

    function handleSaveName(e) {
        e.preventDefault()
        let tmp = []

        for (let i = 1; i < e.target.elements.length; i++)
            if (e.target.elements[i].checked === false)
                tmp.push(e.target.elements[i].value)
        props.setFilters({
            ...props.filters,
            forbidfamilies: tmp
        })
        setOpen2(false)
    }

    function removeAllFamilies(e) {
        setFamilies(Object.keys(props.families))
    }

    function selectAllFamilies(e) {
        setFamilies([])
    }

    function handleChange(e) {
        if (forbidfamilies.includes(e))
            setFamilies(forbidfamilies.filter(elt => elt != e))
        else
            setFamilies([...forbidfamilies, e])
    }

    let byName = <FormControl>
        <TextField
            ref={inputName}
            id="filter"
            onChange={e => changeName(e)}
            type={'text'}
            margin={"dense"}
            label={'Filtering by name'}
            variant={'outlined'}
            value={filters.name}
        />
    </FormControl>

    const families = Object.keys(props.families)
    const dialogName = <Dialog onKeyDown={e => handleCloseName(e)} open={open2} fullWidth={true} maxWidth={"md"}>
        <DialogTitle>Filtering Problems
            <IconButton style={{float: "right", marginTop: "-5px"}} aria-label="close"
                        onClick={e => handleCloseName(e)}>
                <CloseIcon/>
            </IconButton></DialogTitle>
        <form onSubmit={e => handleSaveName(e)}>
            <DialogContent>
                {byName}
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <ButtonGroup color='primary'>
                        <Button size='small' variant='contained' color='primary'
                                onClick={e => removeAllFamilies(e)}
                                disabled={forbidfamilies.length === families.length}>None</Button>
                        <Button size='small' disabled={forbidfamilies.length === 0} variant='contained' color='primary'
                                onClick={e => selectAllFamilies(e)}>All</Button>
                    </ButtonGroup>
                </div>
                <br/><br/>
                <div style={{columnCount: 4}}>
                    {families.sort().map(e =>
                        <FormGroup><FormControlLabel style={{fontSize:"30%!important"}}
                            control={<Checkbox color='primary' name={"c[]"} value={e}
                                               onChange={i => handleChange(e)}
                                               checked={forbidfamilies.includes(e) === false}
                                               defaultChecked={props.filters.forbidfamilies.includes(e) === false}/>}
                            label={e}/></FormGroup>)
                    }
                </div>
            </DialogContent>
            <DialogActions>
                <Button size='small' variant='outlined' onClick={handleCloseName}>Cancel</Button>
                <Button size='small' variant='outlined' color='primary' type='submit'>OK</Button>
            </DialogActions>
        </form>
    </Dialog>


    // --------------------------------------------------------------------------------------------------

    const handleClose = (e) => {
        if (e._reactName === "onKeyDown" && e.keyCode !== 27)
            return;
        setOpen(false);
    }

    function handleOpen(e) {
        e.preventDefault()
        setOpen(true)
    }

    function handleSave(e) {
        e.preventDefault()
        let tmp = []
        for (let i = 2; i < e.target.elements.length; i++)
            if (e.target.elements[i].checked)
                tmp.push(e.target.elements[i].value)

        props.setFilters({
            ...props.filters,
            constraints: {willing: e.target.elements['willing-label'].value === "Yes", types: tmp}
        })
        setOpen(false)
    }

    let dialog = null
    if (props.filters.constraints !== undefined)
        dialog = <Dialog onKeyDown={e => handleClose(e)} open={open} fullWidth={true} maxWidth={"md"}>
            <DialogTitle>Filtering Constraints
                <IconButton style={{float: "right", marginTop: "-5px"}} aria-label="close"
                            onClick={e => handleClose(e)}>
                    <CloseIcon/>
                </IconButton></DialogTitle>
            <form onSubmit={e => handleSave(e)}>
                <DialogContent>
                    <FormControl style={{marginTop: '-20px'}}>
                        <RadioGroup aria-labelledby="willing-label" name="willing-label"
                                    defaultValue={props.filters.constraints.willing ? "Yes" : "No"}>
                            <FormControlLabel value={'Yes'} control={<Radio color="success"/>}
                                              label="Forcing the presence of these constraints"/>
                            <FormControlLabel value={'No'} control={<Radio color="success"/>}
                                              label="Forbidding the presence of these constraints"/>
                        </RadioGroup>
                    </FormControl>
                    <br/><br/>
                    <div style={{marginLeft: '50px', columnCount: '4'}}>
                        {Object.keys(props.constraints).sort().map(e =>
                            <FormGroup><FormControlLabel
                                control={<Checkbox color='primary' name={"c[]"} value={e}
                                                   defaultChecked={props.filters.constraints.types.includes(e)}/>}
                                label={e}/></FormGroup>)
                        }
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button size='small' variant='outlined' onClick={handleClose}>Cancel</Button>
                    <Button size='small' variant='outlined' color='primary' type='submit'>OK</Button>
                </DialogActions>
            </form>
        </Dialog>


    // --------------------------------------------------------------------------------------------------

    function changeSelection(e, selection) {
        e.preventDefault()
        if (selection === "SAT" && props.filters.selection === "SAT")
            selection = "ALL"
        if (selection === "UNSAT" && props.filters.selection === "UNSAT")
            selection = "ALL"
        if (selection === "OPT" && props.filters.selection === "OPT")
            selection = "ALL"
        if (selection === "?" && props.filters.selection === "?")
            selection = "ALL"
        props.setFilters({...props.filters, selection: selection})
    }

    let selection
    if (props.filters.optim) {
        selection = <div style={{display: "flex", "justifyContent": "center", 'marginTop': "10px"}}>
            <ButtonGroup color="primary" aria-label="outlined secondary button group">
                <Button size='small' variant={props.filters.selection === "OPT" ? "contained" : ""}
                        onClick={e => changeSelection(e, "OPT")}>CLOSED</Button>
                <Button size='small' variant={props.filters.selection === "?" ? "contained" : ""}
                        onClick={e => changeSelection(e, "?")}>OPEN</Button>
            </ButtonGroup>
        </div>
    } else {
        selection = <div style={{display: "flex", "justifyContent": "center", 'marginTop': "10px"}}>
            <ButtonGroup color="primary" aria-label="outlined secondary button group">
                <Button size='small' variant={props.filters.selection === "SAT" ? "contained" : ""}
                        onClick={e => changeSelection(e, "SAT")}>SAT</Button>
                <Button size='small' variant={props.filters.selection === "UNSAT" ? "contained" : ""}
                        onClick={e => changeSelection(e, "UNSAT")}>UNSAT</Button>
            </ButtonGroup>
        </div>
    }

    // --------------------------------------------------------------------------------------------------

    function changeType(e, type) {
        e.preventDefault();
        if (type === "max" && props.filters.type === "max")
            type = "ALL"
        if (type === "min" && props.filters.type === "min")
            type = "ALL"
        props.setFilters({...props.filters, type: type})
    }

    const minmax = <div style={{display: "flex", "justifyContent": "center", 'marginTop': "10px"}}>
        <ButtonGroup color="primary" aria-label="outlined secondary button group">
            <Button size='small' variant={props.filters.type === "max" ? "contained" : ""}
                    onClick={e => changeType(e, "max")}>MAX</Button>
            <Button size='small' variant={props.filters.type === "min" ? "contained" : ""}
                    onClick={e => changeType(e, "min")}>MIN</Button>
        </ButtonGroup>
    </div>

    // --------------------------------------------------------------------------------------------------


    function changeFormulaFilter(e) {
        e.preventDefault();
        if (simulate_evaluate(e.target.elements[0].value) === false)
            setErrorVars(true)
        else setErrorVars(false)
        props.setFilters({...props.filters, formula: e.target.elements[0].value})
    }

    function resetFormulaFilter(e) {
        e.preventDefault();
        props.setFilters({...props.filters, formula: ""})
        inputFormula.current.firstChild.firstChild.value = ""
        setErrorVars(false)
    }

    let formula = <FormControl style={{margin: '0 20px'}}>

        <form onSubmit={e => changeFormulaFilter(e)}>
            <TextField
                onChange={e => setFilters({...filters, formula: e.target.value})}
                error={errorVars ? true : null}
                ref={inputFormula}
                id="variables"
                type={'text'}
                margin={"dense"}
                variant={'outlined'}
                label={"Expression"}
                value={filters.formula}
            />
        </form>

    </FormControl>

    // --------------------------------------------------------------------------------------------------


    function changeScoringMethod(e, method) {
        e.preventDefault()
        props.setFilters({...props.filters, scoringMethod: method})
    }


    let scoringMethod = null
    if (false && props.filters.optim)
        scoringMethod = <div style={{display: "flex", "justifyContent": "center", 'marginTop': "10px"}}>
            <ButtonGroup color="primary" aria-label="outlined secondary button group">
                <Button size='small' variant={props.filters.scoringMethod === "DECREASING" ? "contained" : ""}
                        color="primary"
                        onClick={e => changeScoringMethod(e, "DECREASING")}>DEC</Button>
                <Button size='small' variant={props.filters.scoringMethod === "LINEAR" ? "contained" : ""}
                        onClick={e => changeScoringMethod(e, "LINEAR")}>LIN</Button>
                <Button size='small' variant={props.filters.scoringMethod === "BEST" ? "contained" : ""}
                        onClick={e => changeScoringMethod(e, "BEST")}>BEST</Button>
            </ButtonGroup>
        </div>

    // --------------------------------------------------------------------------------------------------
    function deepEqual(object1, object2) {


        const keys1 = Object.keys(object1);
        const keys2 = Object.keys(object2);
        if (keys1.length !== keys2.length) {
            return false;
        }
        for (const key of keys1) {
            const val1 = object1[key];
            const val2 = object2[key];
            const areObjects = isObject(val1) && isObject(val2);
            if (areObjects && !deepEqual(val1, val2) || !areObjects && val1 !== val2)
                return false;
        }
        return true;
    }

    function isObject(object) {
        return object != null && typeof object === 'object';
    }

    function clearFilters(e) {
        e.preventDefault()
        props.setFilters(props.nofilters)
    }

    let clear =
        <div style={{display: "flex", "justifyContent": "center"}}>
            <Button onClick={e => clearFilters(e)} variant={'outlined'} color={"primary"}
                    disabled={deepEqual(props.nofilters, props.filters)} color={"primary"}>Clear All filters</Button>
        </div>

    // --------------------------------------------------------------------------------------------------


    return (
        <div>
            <ListSubheader inset style={{color: '#408033'}}><big><big>Filters</big></big></ListSubheader>
            <br/>
            <div style={{display: "flex", "justifyContent": "center"}}>
                <ButtonGroup>
                    <Button size='small' onClick={e => handleOpenName(e)}
                            color="primary"
                            variant={props.filters.forbidfamilies.length > 0 ? "contained" : "outlined"}>Problems
                    </Button>
                    {dialog === null ? null :
                        <Button size='small' onClick={e => handleOpen(e)}
                                color={"primary"}
                                variant={props.filters.constraints.willing
                                || props.filters.constraints.types.length > 0 ? "contained" : "outlined"}>Constraints</Button>
                    }    </ButtonGroup>
            </div>
            {props.filters.optim ? minmax : null}

            {selection}
            <br/>
            {formula}
            <br/>
            {dialogName}


            {dialog}
            {scoringMethod}
            {time}
            {clear}
            <br/>
        </div>
    )
}